import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalIdentificationContext {
    constructor(public identificationId: number, public customerNumberId: number) {}
}

@Component({
    selector: 'historical-customer-identification-modal',
    templateUrl: './historical-customer-identification-modal.html'
})
export class HistoricalCustomerIdentificationModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerIdentificationModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalIdentificationContext,
        public modalService: MvdModalService
    ) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;
    }

    public ngOnInit(): void { }

    public cancel(): void {
        this.dialogRef.close();
    }
}
